module.exports = __webpack_public_path__ + "img/744.2b4ca43b.jpg";